/**
 * # jQuery required_validate
 * Libreria per la validazione dei campi input presenti nelle form
 */
/**
 * ## How to
 * La libreria funziona mediante l'inserimento di attributi sui tag html di tipo input, select e textarea che definiscono il tipo di validazione che essere svolta.
 *
 * #### Attivazione
 * L'attivazione della validazione su di una form va fatta manualmente partendo da un oggetto jQuery:
 * `$('form').required_validate();`
 *
 * Al metodo required_validate chiamato puo essere passato un *Object* che tramite i parametri specifica il comportamento della singola form. Vedere voce <a href="#default_options">default_options</a>.
 * `$('form').required_validate({ 'valida_key_up': false });`
 *
 * #### Campi obbligatori
 * Per specificare un campo obbligatorio va indicato per l'input l'attributo regola="required" . Es:
 * `<input type="text" name="nome" value="" regola="required" >`
 *
 * #### Campi obbligatori uno di
 * E' possibile specificare validazione di campi required dove pero' ne basta solo uno di quelli richiesti.
 * Per esempio se ci sono 3 check dove non e' obbligatorio che tutti siano checkati ma ne basta anche solo uno.
 * Questa regola si applica con l'attributo "uno_di" dove il valore deve essere una chiave che identifica il legame tra gli input.
 * NB: per essere applicate l'input deve avere l'attributo regola="required".
 * Puo' essere usanto contemporaneamente anche su input con type diverso.
 * `<input type="text" name="nome1" value="" regola="required" uno_di="chiave_legame" >`
 * `<input type="checkbox" name="nome2" value="" regola="required" uno_di="chiave_legame" >`
 * `<input type="checkbox" name="nome3" value="" regola="required" uno_di="chiave_legame" >`
 *
 * #### Validazione regola
 * Con la regola si associa il tag :input uno stadard che deve essere rispettato dal valore inserito.
 * Per indicare alla libreria quale regola verificare va utilizzato l'attributo "valida".
 * Es: `<input type="text" name="nome" value="" valida="email" >`
 *
 * Le regole applicabili sono le seguenti:
 * - **email** Specifica che il valore inserito deve essere una email e rispettarne lo standard
 * - **percentage** Specifica che il valore inserito deve essere una percentuale
 * - **codice_fiscale** Specifica che il valore inserito deve essere un codice fiscale e rispettarne lo standard
 * - **partita_iva** Specifica che il valore inserito deve essere una partita iva e rispettarne lo standard
 * - **cf_pi** Specifica che il valore inserito deve essere un codice fiscale o una partita iva e rispettarne lo standard
 * - **codice_fiscale_senza_zeri** Specifica che il valore inserito deve essere un caodice fiscale non composto da soli zeri e rispettarne lo standard
 * - **partita_iva_senza_zeri** Specifica che il valore inserito deve essere una partita iva non composta da soli zeri e rispettarne lo standard
 * - **cf_pi_senza_zeri** Specifica che il valore inserito deve essere un codice fiscale o una partita iva non composti da soli zeri e rispettarne lo standard
 * - **data** Specifica che il valore inserito deve essere una data e rispettarne lo standard in formato italiano "gg/mm/aaaa"
 * - **ora** Specifica che il valore inserito deve essere un orario e rispettarne lo standard "hh:mm"
 * - **data_ora** Specifica che il valore inserito deve essere una data con orario e rispettarne lo standard "gg/mm/aaaa hh:mm"
 * - **url** Specifica che il valore inserito deve essere un url e rispettarne lo standard
 * - **int** Specifica che il valore inserito deve essere un intero
 * - **valida_cifra** Specifica che il valore inserito deve essere un valore numerico e rispettarne lo standard in formato italiano es: 1.000,00
 * - **valore_min** Specifica che il valore inserito deve parire da un determinato valore minimo.
 * Puo' verificare sia cifre che date in formato italiano, puo' essere utilizzato in combinazione con valore_max aggiungendo nell'attributo "valida" entrambe le regole separate da uno spazio.
 * E' obbligatorio specificare per l'input un attributo "valore_min" che definisce il valore minimo. es valore_min="01/01/2015"
 * Puo' essere specificato un ulteriore attributo valore_uguale="valore_uguale" per indicare se il confronto debba essere "meggiore o uguale di". Di default il confronto e' "maggiore di".
 * - **valore_max** Specifica che il valore inserito non puo' superare un determinato valore massimo.
 * Puo' verificare sia cifre che date in formato italiano, puo' essere utilizzato in combinazione con valore_min aggiungendo nell'attributo "valida" entrambe le regole separate da uno spazio.
 * E' obbligatorio specificare per l'input un attributo "valore_max" che definisce il valore massimo. es valore_max="01/01/2016"
 * Puo' essere specificato un ulteriore attributo valore_uguale="valore_uguale" per indicare se il confronto debba essere "minore o uguale di". Di default il confronto e' "minore di".
 * - **regex** Specifica che il valore inserito deve matchare una determinata espressione regolare. L'espressione regolare va specificata nell'attributo "rv_regex" da associare l'input.
 * es campo input password dove posso inserire solo determinati parametri come "numeri", "lettere minuscole", "-", "\_", "." : rv_regex="[a-z]|[0-9]|-|_|\."
 *
 * #### Validazione custom
 * E' possibile specificare all'occorrenza un metodo personalizzato per validare un input. Per farlo bisogna chiamare il metodo "required_validate_custom_validation" e passargli la funzione di validazione:
 * All'interno della funzione la variabile this e' sempre l'oggetto jQuery relativo all'input.
 * La funzione dichiarata deve ritornare sempre un valore booleano, se cosi' non fosse l'input viene considerato valido in ogni caso.
 * `$(input)`
 * `.required_validate_custom_validation(function(){`
 * `return $(this).val() == 1;`
 * `});`
 *
 * #### Validazione campi uguali
 * Per specificare che due campi devono essere uguali utilizzare l'attributo "confronta" dove il valore deve essere una stringa uguale per i campi da confrontare.
 * `<input type="text" name="nome1" value="" confronta="chiave_legame">`
 * `<input type="text" name="nome2" value="" confronta="chiave_legame">`
 *
 * #### Validazione input range
 * Per gli input multipli che richiedono una logica "da-a" si possono utilizzare gli attributi "valida_da" e "valida_a" dove il valore deve essere uguale e identifica la coppia degli input.
 * Possono essere controllati intervalli numerici o date in formato italiano.
 * `<input type="text" name="nome1" value="" valida_da="chiave_legame">`
 * `<input type="text" name="nome2" value="" valida_a="chiave_legame">`
 *
 * #### Validazione lunghezza minima
 * E' possibile specificare una lunghezza minima per il campo tramite l'attributo "minlength" e valore numerico.
 * `<input type="text" name="nome" value="" minlength="5" >`
 *
 * #### Validazione estensione file da caricare
 * E' possibile vincolare il formato dei file da caricari per gli input type="file", utilizzare l'attributo "estensione" e specificare come valore il nome dell'estensione (senza il punto all'inizio).
 * Possono essere inserite piu' estensioni valide separate dal carattere pipe "|"
 * `<input type="file" name="nome" value="" estensione="pdf|doc" >`
 *
 * #### Validazione singolo input
 * Ogni metodo di validazione puo' essere usato singolarmente anche senza l'attivazione di una form da validare. Ritornano sempre un valore booleano.
 * Questi metodi possono essere utilizzati direttamente su ogni input chiamando il corrispondente. Le logiche degli attributi devono essere rispettate.
 * Vedere <a href="#metodi-pubblici">Metodi pubblici</a>
 * Es: $('input').required_validate_is_email();
 *
 * #### Ispezione eventi bindati
 * Questa libreria mette a disposizione un metodo che permette di stampare a console l'elenco degli eventi bindati e corrispondente codice eseguito per ogni elemento della pagina.
 * `$.required_validate.event_report();`
 * Per ottenre invece gli eventi per un determinato oggetto appartenente al DOM richiamare il metodo sull'oggetto jquery:
 * `$(elemento).required_validate_event_report();`
 *
 * #### Alert errori
 * Per segnalare un errore e' possibile aggiungere al tag :input un attributo "alert" dove il suo valore e' una stringa con il messaggio.
 * NB: non serve aggiungere all'inizio parole tipo "Attenzione:". La libreria automaticamente genera l'avviso.
 * Nel caso di piu' avvisi l'alert visualizzato e' unico con l'elenco dei problemi che si sono verificati.
 * `<input type="text" name="nome" value="" valida="email" alert="Inserire un indirizzo email valido" >`
 *
 * #### Lanciare la validazione manualmente
 * Per falidare la form manualmente e' sufficiente reinvocare il metodo required_validate() sull'oggetto jQuery della form:
 * `$(form).required_validate();`
 * Se strettamente necessario e' possibile invocare in un colpo solo la validazione di tutte le form su cui e' attiva questa libreria:
 * `$.required_validate.validate_all();`
 *
 * #### Altre info
 * La libreria effettua un controllo degli eventi bindati su ogni input ed esegue sempre l'evento di validazione per ultimo in modo che non vi siano altre funzioni successive al processo di validazione che intervengono modificando il DOM.
 *
 */

/**
 * Verifica preliminare requisiti
 * La libreria richiede: jQuery >= 1.9.1
 */
if (typeof jQuery === 'undefined') {
  throw new Error('jQuery required_validate necessita di jQuery');
}

!function ($) {
  'use strict';
  var version = $.fn.jquery.split(' ')[0].split('.')
  if (version[0] < 1 || (version[0] == 1 && version[1] < 7) || (version[0] == 1 && version[1] == 7 && version[2] < 1)) {
    throw new Error('jQuery required_validate necessita di jQuery >= 1.7.1');
  }
}(jQuery);

!function($) {

  if($.required_validate !== undefined){
    return console && console.warn("Required validate: libreria gia' inizializzata");
  }

  $.extend($.fn, {
    onFirst: function(name, fn) {
      return this.each(function(i, elem){
        $(elem).on(name, fn);
        var handlers = jQuery._data(elem).events[name.split('.')[0]];
        handlers.unshift(handlers.pop());
      });
    }
  });

  // ## Definizione prototipi della libreria

  /**
   * ### rv_input_obj
   * Creazione e implementazione del prototipo *input*
   * NB: I seguenti metodi non sono accessibili pubblicamente
   */
  function rv_input_obj ( input, form ){
    this.$input = input;
    this.form_obj = form;
    this.initialized = false;
    this.valid_state = true;
  }

  rv_input_obj.prototype = {
    init: function(){
      if( this.initialized || this.$input.data( 'rv_object' ) ) { return this.$input.data( 'rv_object' ); }
      this.$input.data( 'rv_object', this );
      this.initialized = true;
      this.apply_mask().events_to_bind();
      this.$input.addClass( $.required_validate.default_options.input_class );
      return this;
    },
    is_inizialized: function(){
      !this.initialized && window.console && console.warn("Required validate: input non inizializzato", this.$input);
      return this.initialized;
    },
    apply_mask: function(){
      if( !this.is_inizialized || !this.$input.attr('rv_mask') ){ return this; }
      switch (this.$input.attr('rv_mask')){
        case 'cifra':
          this.$input.required_validate_mask_cifra();
          break;
        default:
          this.$input.required_validate_mask_test();
          break;
      }
      return this;
    },
    events_to_bind: function(){
      if( !this.is_inizialized ){ return this; }
      var self = this;
      self.$input.on({
        'click.rv' : function(){
          self.check_if_last_triggered(self);
        },
        'keyup.rv': function(){
          if(self.form_obj.options.valida_key_up || $.fn.valida_keyup === true){
            self.form_obj.validate( 'keyup' );
          } else {
            if (self.off){
              self.off( 'keyup.rv' );
            }else{
              try{
                self.$input.off('keyup.rv' );
              }catch (e) {
                console.warn("Reuired validate: ", "Impossibile rimuovere l'evento keyup.rv")
              }
            }
          }
        },
        'change.rv': function(){
          self.form_obj.validate( 'change' );
        }
      });
      if( self.$input.attr('rv_forcewrite') ){
        self.$input.on("paste.rv", function(e) {
          e.preventDefault();
        });
      }
      return this;
    },
    check_if_last_triggered: function(){
      var e = $._data( this.$input, 'events');
      $( this.$input ).off('click.rv');
      if(!e) return;
      if(e['keyup']){ //evento keyup
        for(var i = 0, l = e['keyup'].length; i < (l - 1); i++){
          var handlerObj = e['keyup'][i];
          if(handlerObj.namespace && handlerObj.namespace === 'rv'){
            e['keyup'].move_element(i, l - 1); break;
          }
        }
      }
      if(e['change']){ //evento change
        for(var i = 0, l = e['change'].length; i < (l - 1); i++){
          var handlerObj = e['change'][i];
          if(handlerObj.namespace && handlerObj.namespace === 'rv'){
            e['change'].move_element(i, l - 1); break;
          }
        }
      }
      return;
    },
    clean_class: function(){
      this.$input.add( this.$input.parent('label') )
        .removeClass('required_field error')
        .removeClass(function(i, className){
          var re = new RegExp('(^|\\s)' + ($.required_validate.default_options.class_prefix) + '\\S+', 'g');
          return (className.match( re ) || []).join(' ');
        });
      return this;
    },
    error_highlight: function(){
      this.$input.addClass('inputStyle');
      var $target = this.$input.add( this.$input.parent('label') ).add( this.$input.parent('label') );
      //setto la classe giusta
      if( !this.valid_state ){
        if( this.$input.attr('regola') === 'required' &&
          ((this.$input.is(':radio') && this.form_obj.$form.find('[name="' + this.$input.attr('name') + '"]:checked').length <= 0 ) ||
            (this.$input.is(':checkbox') && !this.$input.is(':checked')) ||
            this.is_empty_input()) ){
          $target.addClass( $.required_validate.default_options.class_prefix +
            $.required_validate.default_options.required_class );
          if( !$.required_validate.css_class.rv_required ){
            $target.css('background-color', '#FFFFCC');
          }
        }
        else {
          this.$input.addClass( $.required_validate.default_options.class_prefix +
            $.required_validate.default_options.error_class );
          if( !$.required_validate.css_class.rv_error ){
            this.$input.css('background-color', '#FFA500');
          }
        }
      }
      else {
        $target.addClass( $.required_validate.default_options.class_prefix +
          $.required_validate.default_options.valid_class );
        if( !$.required_validate.css_class.rv_required || !$.required_validate.css_class.rv_error ){
          $target.css('background-color', '');
        }
      }
      return this;
    },
    /* boolean methods */
    is_valid: function(){
      this.clean_class();
      this.valid_state = true;
      if( this.is_validable() ){
        this.valid_state = (this.check_required() &&
          this.check_role() &&
          this.check_match_fields() &&
          this.check_min_length() &&
          this.check_invalid_file_extension() &&
          this.check_invalid_ranges()
        ) ? true : false;
      }
      this.error_highlight();
      var e = $.Event('validated.rv', { valid: this.valid_state });
      this.$input.trigger(e);
      return this.valid_state;
    },
    is_validable: function(){
      if( this.form_obj.options.check_disabled === false && this.$input.is(':disabled') ){
        return false;
      }
      if (this.form_obj.options.check_readonly === false && this.$input.attr('readonly')) {
        return false;
      }
      if( this.form_obj.options.check_hidden === false && this.$input.attr('type') === 'hidden' ){
        return false;
      }
      if( !this.$input.val || !this.$input.attr('name') || $.trim(this.$input.attr('name')).length <= 0 ){
        return false;
      }
      return true;
    },
    is_empty_input: function(){
      if( this.$input.attr('type') == 'radio' ){
        return this.$input.closest('form').find('input[type="radio"][name="' + this.$input.attr('name') + '"]:checked').length <= 0 ? true : false;
      }
      else if( this.$input.attr('type') == 'checkbox' ){
        return this.$input.is(':checked') ? false : true;
      } else {
        if( this.$input.attr('placeholder') == this.$input.val() ){ /* fix old ie */
          return true;
        }
        return ( $.trim(this.$input.val()).length <= 0 || (this.$input.attr('valida') && this.$input.attr('valida').match(/(data)|(ora)|(data_ora)/) && this.$input.val().match(/_/)) ) ? true : false;
      }
    },
    check_required: function(){
      if(this.$input.attr('regola') !== 'required'){
        return true;
      }
      var is_valid = !this.is_empty_input();
      if( !is_valid && this.$input.attr('uno_di') && $.trim(this.$input.attr('uno_di')).length > 0 ){
        var form_inputs_obj = this.form_obj.inputs_obj, uno_di = this.$input.attr('uno_di');
        for( var i = 0, l = form_inputs_obj.length; i < l; i++ ){
          var $cur_input = form_inputs_obj[i].$input;
          if( !$cur_input.attr('uno_di') || $cur_input.attr('uno_di') !== uno_di ){ continue; }
          if( !form_inputs_obj[i].is_validable() ){ continue; }
          if( form_inputs_obj[i].is_empty_input() ){ continue; }
          if( !this.$input.is($cur_input) ){
            is_valid = true; break;
          }
        }
      }
      return is_valid;
    },
    check_role: function(){
      if( !this.$input.attr('valida') ){
        return true;
      }
      var is_valid = true, array_valida = this.$input.attr('valida').split(' ');
      for( var i = 0, l = array_valida.length; i < l; i++ ){
        if( array_valida[i].length <= 0 ){ continue; }
        switch ( array_valida[i] ){
          case 'email':
            is_valid = $.required_validate.is_email(this.$input.val());
            break;
          case 'percentage':
            is_valid = $.required_validate.is_percentage(this.$input.val());
            break;
          case 'codice_fiscale':
            is_valid = $.required_validate.is_codice_fiscale(this.$input.val());
            break;
          case 'partita_iva':
            is_valid = $.required_validate.is_partita_iva(this.$input.val());
            break;
          case 'cf_pi':
            is_valid = $.required_validate.is_cf_pi(this.$input.val());
            break;
          case 'codice_fiscale_senza_zeri':
            is_valid = $.required_validate.is_codice_fiscale_senza_zeri(this.$input.val());
            break;
          case 'partita_iva_senza_zeri':
            is_valid = $.required_validate.is_partita_iva_senza_zeri(this.$input.val());
            break;
          case 'cf_pi_senza_zeri':
            is_valid = $.required_validate.is_cf_pi_senza_zeri(this.$input.val());
            break;
          case 'data':
            is_valid = $.required_validate.is_date(this.$input.val());
            break;
          case 'ora':
            is_valid = $.required_validate.is_ora(this.$input.val());
            break;
          case 'data_ora':
            is_valid = $.required_validate.is_date_hour(this.$input.val());
            break;
          case 'url':
            is_valid = $.required_validate.is_url(this.$input.val());
            break;
          case 'int':
            is_valid = $.required_validate.is_integer(this.$input.val());
            break;
          case 'valida_cifra':
            is_valid = $.required_validate.is_cifra(this.$input.val());
            break;
          case 'valore_min':
            is_valid = $.required_validate.is_greater_than(this.$input);
            break;
          case 'valore_max':
            is_valid = $.required_validate.is_lower_than(this.$input);
            break;
          case 'regex':
            is_valid = $.required_validate.is_valid_regex(this.$input);
            break;
        }
        if( !is_valid ){ break; }
        if( array_valida[i].indexOf('rv_c_', 0) >= 0 ){
          var v = !$.required_validate[ array_valida[i] ] ? true : $.required_validate[ array_valida[i] ].apply(this.$input);
          is_valid = v === undefined || typeof v != "boolean" ? true : v;
        }
        if( !is_valid ){ break; }
      }
      if( !is_valid && this.$input.attr('alert') ){
        this.form_obj.add_error( this.$input.attr('alert') );
      }
      return is_valid;
    },
    check_match_fields: function(){
      if(!this.$input.attr('confronta')){
        return true;
      }
      var is_valid = true, form_inputs_obj = this.form_obj.inputs_obj, confronta = this.$input.attr('confronta');
      for( var i = 0, l = form_inputs_obj.length; i < l; i++ ){
        var $cur_input = form_inputs_obj[i].$input;
        if( !$cur_input.attr('confronta') || $cur_input.attr('confronta') !== confronta ){ continue; }
        if( !form_inputs_obj[i].is_validable() ){ continue; }
        if( form_inputs_obj[i].is_empty_input() ){ continue; }
        if( !this.$input.is($cur_input) ){
          if( $cur_input.val() !== this.$input.val() ){
            is_valid = false;
            form_inputs_obj[i].error_highlight();
          }
          break;
        }
      }
      if( !is_valid && this.$input.attr('alert') ){
        this.form_obj.add_error( this.$input.attr('alert') );
      }
      return is_valid;
    },
    check_min_length: function(){
      if( !this.$input.attr('minlength') || $.trim(this.$input.val()).length <= 0 ){
        return true;
      }
      if( this.$input.val().length < parseInt(this.$input.attr('minlength'), 10) ){
        if( this.$input.attr('alert') ){
          this.form_obj.add_error( this.$input.attr('alert') );
        }
        return false;
      }
      return true;
    },
    check_invalid_file_extension: function(){
      if( this.$input.attr('type') !== 'file' || !this.$input.attr('estensione') || $.trim(this.$input.val()).length <= 0 ){
        return true;
      }
      var estensione_file = this.$input.val().split('.').pop().toLowerCase(),
          estensioni_ammesse = this.$input.attr('estensione').toLowerCase().split('|');
      if( $.inArray(estensione_file, estensioni_ammesse) < 0 ){
        if( this.$input.attr('alert') ){
          this.form_obj.add_error( this.$input.attr('alert') );
        }
        return false;
      }
      return true;
    },
    check_invalid_ranges: function(){
      if( !this.$input.attr('valida_da') && !this.$input.attr('valida_a') ){
        return true;
      }
      var is_da = this.$input.attr('valida_da') !== undefined,
          match = is_da ? this.$input.attr('valida_da') : this.$input.attr('valida_a'),
          form_inputs_obj = this.form_obj.inputs_obj,
          matched_element = false;
      for( var i = 0, l = form_inputs_obj.length; i < l; i++ ){
        var $cur_input = form_inputs_obj[i].$input;
        if( !$cur_input.attr( (is_da ? 'valida_a' : 'valida_da') ) || $cur_input.attr( (is_da ? 'valida_a' : 'valida_da') ) !== match ){ continue; }
        if( !form_inputs_obj[i].is_validable() ){ continue; }
        if( form_inputs_obj[i].is_empty_input() ){ continue; }
        if( !this.$input.is( $cur_input ) ){
          matched_element = form_inputs_obj[i];
          break;
        }
      }
      if( !matched_element ){ return true; }
      var is_valid = true,
          array_valida_this_element = this.$input.attr('valida') ? this.$input.attr('valida').split(' ') : [],
          array_valida_matched_element = matched_element.$input.attr('valida') ? matched_element.$input.attr('valida').split(' ') : [];
      if( $.inArray('data', array_valida_this_element) >= 0 && $.inArray('data', array_valida_matched_element) >= 0 ){
        if ( !$.required_validate.regexs.date_blank.test(this.$input.val()) &&
          !$.required_validate.regexs.date_blank.test(matched_element.$input.val()) &&
          $.required_validate.is_date(this.$input.val()) &&
          $.required_validate.is_date(matched_element.$input.val())) {
          var parti_data_this = this.$input.val().split('/'),
              parti_data_matched = matched_element.$input.val().split('/'),
              data_this = new Date(parseInt(parti_data_this[2], 10), parseInt(parti_data_this[1], 10) - 1, parseInt(parti_data_this[0], 10)),
              data_matched = new Date(parseInt(parti_data_matched[2], 10), parseInt(parti_data_matched[1], 10) - 1, parseInt(parti_data_matched[0], 10));
          if( is_da ){
            if( data_this.getTime() > data_matched.getTime() ){
              is_valid = false;
            }
          } else {
            if( data_this.getTime() < data_matched.getTime() ){
              is_valid = false;
            }
          }
          if( !is_valid ){
            matched_element.error_highlight();
          }
        }
      }
      else if( this.$input.attr('rv_mask') === 'cifra' ){
        is_valid = is_da ?
          $.required_validate.italian_number_to_decimal(this.$input.val()) <= $.required_validate.italian_number_to_decimal(matched_element.$input.val()) :
          $.required_validate.italian_number_to_decimal(this.$input.val()) >= $.required_validate.italian_number_to_decimal(matched_element.$input.val());
      }
      else {
        is_valid = is_da ?
          parseInt(this.$input.val(), 10) <= parseInt(matched_element.$input.val(), 10) :
          parseInt(this.$input.val(), 10) >= parseInt(matched_element.$input.val(), 10);
      }
      return is_valid;
    }
  };

  /**
   * ### rv_form_obj
   * Creazione e implementazione del prototipo *form*
   * NB: I seguenti metodi non sono accessibili pubblicamente
   */
  function rv_form_obj ( form ){
    this.$form = $(form);
    this.initialized = false;
    this.$submits = null;
    this.inputs_obj = [];
    this.options = {};
    this.errors = [];
  }

  rv_form_obj.prototype = {
    init: function( options ){
      if( this.initialized || this.$form.data( 'rv_object' ) ) { return this.$form.data( 'rv_object' ); }
      if(this.$form.prop('tagName').toLowerCase() != 'form'){
        window.console && console.warn("Required validate: l'elemento non e' una form");
        return this;
      }
      this.$form.data( 'rv_object', this );
      this.options = $.extend({}, $.required_validate.default_options, options);
      if(this.options.disable_html5_validate){
        this.$form.attr('novalidate', 'novalidate');
      }
      this.$form.attr('autocomplete', this.options.autocomplete ? 'on' : 'off');
      this.initialized = true;
      this.load_inputs();
      if(this.options.disable_on_submit){
        var self = this;
        self.$form.submit(function(){
          self.$submits.attr('disabled', true);
        });
      }
      return this;
    },
    load_inputs: function( reload ){
      if( reload === true ){
        for( var i = 0, l = this.inputs_obj.length; i < l; i++ ){ delete this.inputs_obj[i]; }
        this.inputs_obj = [];
      }
      var inputs = this.$form.find(':input').filter(':not([type="submit"]):not([type="button"])'),
          cur_input_obj = this.inputs_obj;
      for( var i = 0, l = inputs.length; i < l; i++ ){
        var $input = $(inputs[i]), is_ok = false;
        if( $input.hasClass('rv_none') ){ continue; }
        for( var j = 0, k = cur_input_obj.length; j < k; j++ ){
          if( $input.is(cur_input_obj[j].$input) ){
            is_ok = true;
            break;
          }
        }
        if( is_ok ){ continue; }
        var new_input = new rv_input_obj( $input, this );
        this.inputs_obj.push( new_input );
        new_input.init();
      }
      this.$submits = this.get_submit();
      return this;
    },
    get_submit: function(){
      return this.$form.find('[type="submit"],input[target],button[target]').add( this.options.targets );
    },
    validate: function( event ){
      if( !this.is_inizialized ){ return this; }
      if( !event ){ event = ''; }
      this.errors = [];
      var validable_input_exist = false;
      for(var i = 0, l = this.inputs_obj.length; i < l; i++){
        if( this.inputs_obj[i].is_validable() ){
          validable_input_exist = true;
        } else {
          this.inputs_obj[i].clean_class();
        }
      }
      if( !validable_input_exist ){
        this.update_submit( false );
        return this;
      }
      var is_valid = true;
      for(var i = 0, l = this.inputs_obj.length; i < l; i++){
        if( !this.inputs_obj[i].is_valid() ){
          is_valid = false;
        }
      }
      if( this.options.load_submit_disabled && (document.readyState !== 'complete' || event === 'add_form' || $.required_validate.something_is_loading === true) ){
        this.update_submit( false );
      } else {
        this.update_submit( is_valid );
        var e = $.Event('form_validated.rv', { is_valid: is_valid });
        this.$form.trigger(e);
      }
      if( !is_valid && event != 'keyup' ){
        this.show_alert_error();
      }
      return this;
    },
    update_submit: function( can_submit ){
      if( can_submit === undefined ){ can_submit = false; }
      this.$submits.attr('disabled', !can_submit);
      return this;
    },
    is_inizialized: function(){
      !this.initialized && window.console && console.warn("Required validate: form non inizializzata");
      return this.initialized;
    },
    add_error: function( str ){
      this.errors.push( str );
      return this;
    },
    show_alert_error: function(){
      if( this.errors.length > 0 ){
        var alert_message = '';
        for( var i = 0, l = this.errors.length; i < l; i++ ){
          if(alert_message !== ''){
            alert_message += '\n';
          }
          alert_message += '- ' + this.errors[i];
        }
        alert('Attenzione:\n' + alert_message);
      }
      this.errors = [];
      return this;
    },
    get_input_obj: function( $input ){
      for(var i = 0, l = this.inputs_obj.length; i < l; i++){
        if( $input.is(this.inputs_obj[i].$input) ){
          return this.inputs_obj[i];
        }
      }
      return false;
    },
    get_invalid_inputs: function( return_objs ){
      var inputs = [];
      for(var i = 0, l = this.inputs_obj.length; i < l; i++){
        if( !this.inputs_obj[i].valid_state ){
          inputs.push( return_objs ? this.inputs_obj[i] : this.inputs_obj[i].$input );
        }
      }
      return inputs;
    }
  };

  /**
   * ### required_validate
   * Creazione e implementazione del prototipo per la gestione delle validazioni
   */

  function required_validate(){
    this.forms_obj = [];
    /**
     * #### default_options
     * - **disable_html5_validate** {Boolean} [default true] se true indica al browser di non utilizzare la validazione html5 di default, settarlo a false non e' una buona idea
     * - **check_hidden** {Boolean} [default true] se true valida anche i campi input[type="hidden"]
     * - **check_disabled** {Boolean} [default false] se true valida anche i  campi input[disabled]
     * - **valida_key_up** {Boolean} [default true] se true valida in realtime al keyup, altrimenti solo all'evento change
     * - **debug** {Boolean} [default false] se true attiva la modalita' di debug
     * - **disable_on_submit** {Boolean} [default false] se impostato a true all'evento submit della form viene disabilitato automaticamente il pulsante. Questa funzione puo' essere utile per evitare click ripetuti
     * - **load_submit_disabled** {Boolean} [default false] se true il submit viene disattivato di default e si attiva solo se la form viene modificata
     * - **autocomplete** {Boolean} [default false] se true abilita l'autocompletamento sui campi della form da parte del browser
     * - **class_prefix** {String} [default rv_] prefisso applicato alle classi che definiscono lo stato dell'input
     * - **error_class** {String} [default error] nome della classe assegnata al campo input nel caso di errore
     * - **valid_class** {String} [default valid] nome della classe assegnata al campo input nel caso di input valido
     * - **required_class** {String} [default required] nome della classe assegnata al campo input nel caso l'input sia vuoto e richiesto
     */
    this.default_options = {
      disable_html5_validate: true,
      check_hidden          : true,
      check_disabled        : false,
      check_readonly        : false,
      valida_key_up         : true,
      debug                 : false,
      disable_on_submit     : false,
      load_submit_disabled  : false,
      autocomplete          : false,
      class_prefix          : 'rv_',
      error_class           : 'error',
      valid_class           : 'valid',
      required_class        : 'required',
      input_class           : 'input-rv',
      targets               : []
    };
    /**
     * #### regexs
     * Definizione delle espressioni regolari standard per la validazione dei campi in base la tipo
     */
    this.regexs = {
      'url' : /^([--:\w?@%&+~#=]*\.[a-z]{2,4}\/{0,2})((?:[?&](?:\w+)=(?:\w+))+|[--:\w?@%&+~#=]+)?$/i,
      'date_blank' : /^(_{2}\/_{2}\/_{4})$/,
      'date' : /^([0-9]{2})(\/)([0-9]{2})(\/)([0-9]{4})$/,
      'hour_blank' : /^(_{2}:_{2})$/,
      'hour' : /^([0-9]{2})(:)([0-9]{2})$/,
      'date_hour_blank' : /^(_{2}\/_{2}\/_{4})( )+(_{2}:_{2})$/,
      'date_hour' : /^([0-9]{2}\/[0-9]{2}\/[0-9]{4})( )+([0-9]{2}:[0-9]{2})$/,
      'piva' : /^[0-9]{11}$/,
      'codice_fiscale' : /^[A-Z0-9]{16}$/i,
      'it_number': /^([0-9]{1,3}\.([0-9]{3}\.)*[0-9]{3}|[0-9]+)(,[0-9][0-9])$/,
      'int' : /^(([1-9][0-9]*)|(0{1}))$/,
      'percentage': /^(-)?100(\,[0]{1,3})?$|^(-)?[0-9]{1,2}(\,[0-9]{1,3})?$/,
      'email' : /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    };
    /**
     * #### css_class
     * Verifica delle classi css, la libreria all'avvio controlla se e' presnete un css con le regole per la colorazione dei campi.
     * In caso negativo aggiunge dello stile in linea per evidenziare lo stato degli input.
     */
    this.css_class = {
      rv_required: false,
      rv_error: false
    };

    this.something_is_loading = false;
  }

  required_validate.prototype = {
    init: function(){
      if($.required_validate !== undefined){
        return window.console && console.warn("Required validate: libreria gia' inizializzata");
      }
      $.required_validate = this;
      this.check_css();
      return $.required_validate;
    },
    check_css: function(){
      var css = document.styleSheets;
      for (var i=0; i < css.length; i++) {
        if(css[i].href && css[i].href.toLowerCase().indexOf(window.location.hostname) < 0){
          continue;
        }
        try { if(!css[i].rules && !css[i].cssRules){ continue; }
        } catch(e) {
          continue;
        }
        var rules = css[i].rules || css[i].cssRules;
        for(var k=0; k < rules.length; k++){
          if(rules[k].selectorText && typeof rules[k].selectorText == 'string'){
            if(rules[k].selectorText.toLowerCase().indexOf('rv_required') > 0){
              this.css_class.rv_required = true;
            } else if (rules[k].selectorText.toLowerCase().indexOf('rv_error') > 0){
              this.css_class.rv_error = true;
            }
            if( this.css_class.rv_required && this.css_class.rv_error ){ break; }
          }
        }
        if( this.css_class.rv_required && this.css_class.rv_error ){ break; }
      }
      return this;
    },
    get_forms: function(){
      var $forms = [];
      for(var i = 0, l = this.forms_obj.length; i < l; i++){
        $forms.push( this.forms_obj[i].$form );
      }
      return $forms;
    },
    add_form: function( $form, options ){
      if( $form.prop( 'rv_form_index') ){ return this; }
      if( options === undefined ){ options = {}; }
      var rv_form = new rv_form_obj( $form );
      rv_form.init( options );
      var l = this.forms_obj.push( rv_form );
      $form.prop( 'rv_form_index', (l - 1).toString() );
      rv_form.validate('add_form');
      rv_form.dom_observer = new dom_form_observer( rv_form );
      return this;
    },
    get_form_obj: function( $form ){
      if( $form.prop( 'rv_form_index' ) ){
        return this.forms_obj[ $form.prop( 'rv_form_index' ) ];
      }
      return false;
    },
    validate_all: function(){
      for(var i = 0, l = this.forms_obj.length; i < l; i++){
        this.forms_obj[i].validate();
      }
      return this;
    },
    /* rv methods */
    is_email: function( str ){
      if( str === undefined || $.trim(str) === '' ){ return true; }
      if( /(^;)|(;\s*;)|(;$)/.test(str) ) return false;
      var state = true;
      var regEmail = this.regexs.email;
      $.each( str.split(';'), function( i, part ){
        if( !regEmail.test(part) ){
          state = false; return false;
        }
      });
      return state;
    },
    is_percentage: function( str ){
      if( str === undefined || $.trim(str) === '' ){ return true; }
      return this.regexs.percentage.test(str);
    },
    is_codice_fiscale: function( cf ){
      if( cf === undefined || $.trim(cf) === '' || cf == '0000000000000000' ){
        return true;
      }
      cf = $.trim(cf).toUpperCase();
      if( !this.regexs.codice_fiscale.test(cf) ){
        return false;
      }
      var set1 = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ", set2 = "ABCDEFGHIJABCDEFGHIJKLMNOPQRSTUVWXYZ", setpari = "ABCDEFGHIJKLMNOPQRSTUVWXYZ", setdisp = "BAKPLCQDREVOSFTGUHMINJWZYX",
          s = 0;
      for( i = 1; i <= 13; i += 2 ){
        s += setpari.indexOf( set2.charAt( set1.indexOf( cf.charAt(i) )));
      }
      for( i = 0; i <= 14; i += 2 ){
        s += setdisp.indexOf( set2.charAt( set1.indexOf( cf.charAt(i) )));
      }
      return ( s % 26 != cf.charCodeAt(15) - 'A'.charCodeAt(0) ) ? false : true;
    },
    is_partita_iva: function( pi ){
      if( pi === undefined || $.trim(pi) === '' || pi == '00000000000' ){
        return true;
      }
      pi = $.trim(pi);
      if( !this.regexs.piva.test(pi) ){
        return false;
      }
      s = 0;
      for( i = 0; i <= 9; i += 2 ){
        s += pi.charCodeAt(i) - '0'.charCodeAt(0);
      }
      for( i = 1; i <= 9; i += 2 ){
        c = 2*( pi.charCodeAt(i) - '0'.charCodeAt(0) );
        if( c > 9 ) {
          c = c - 9;
        }
        s += c;
      }
      return ( (10 - s % 10) % 10 != pi.charCodeAt(10) - '0'.charCodeAt(0) ) ? false : true;
    },
    is_cf_pi: function( ci_pi ){
      return ( this.is_codice_fiscale(ci_pi) || this.is_partita_iva(ci_pi) ) ? true : false;
    },
    is_codice_fiscale_senza_zeri: function( cf ){
      if( cf === '0000000000000000' ){ return false; }
      return this.is_codice_fiscale(cf);
    },
    is_partita_iva_senza_zeri: function( pi ){
      if( pi === '00000000000' ){ return false; }
      return this.is_partita_iva(pi);
    },
    is_cf_pi_senza_zeri: function( cf_pi ){
      if( cf_pi === '0000000000000000' || cf_pi === '00000000000' ){ return false; }
      return this.is_cf_pi(cf_pi);
    },
    is_date: function( dtStr ){
      if( dtStr === undefined || $.trim(dtStr) === '' || this.regexs.date_blank.test(dtStr) ){
        return true;
      }
      dtStr = $.trim(dtStr);
      var array_data = this.regexs.date.exec(dtStr);
      if(!array_data || array_data === null){ return false; }
      var giorno = parseInt(array_data[1], 10),
          mese = parseInt(array_data[3], 10),
          anno = parseInt(array_data[5], 10),
          daysInMonth = new Date(anno, mese, 0).getDate();
      if(giorno <= 0 || giorno > daysInMonth){ return false; }
      if(mese <= 0 || mese > 12){ return false; }
      if(anno < 1900 || anno > 2100){ return false; }
      return true;
    },
    is_ora: function(oraStr){
      if(oraStr === undefined || $.trim(oraStr) === '' || this.regexs.hour_blank.test(oraStr)){
        return true;
      }
      oraStr = $.trim(oraStr);
      var array_ora = this.regexs.hour.exec(oraStr);
      if(!array_ora || array_ora === null){ return false; }
      var h = parseInt(array_ora[1], 10),
          m = parseInt(array_ora[3], 10);
      if(h < 0 || h > 23){ return false; }
      if(m < 0 || m > 59){ return false; }
      return true;
    },
    is_date_hour: function(dtStr){
      if(dtStr === undefined || $.trim(dtStr) === '' || this.regexs.date_hour_blank.test(dtStr)){
        return true;
      }
      dtStr = $.trim(dtStr);
      var array_data = this.regexs.date_hour.exec(dtStr);
      if(!array_data || array_data === null){
        return false;
      }
      var v = this.is_date(array_data[1]);
      v ? v = this.is_ora(array_data[3]) : 1;
      return v;
    },
    is_url: function(url){
      if(url === undefined || $.trim(url) === ''){ return true; }
      return this.regexs.url.test(url);
    },
    is_integer: function(val){
      if(val === undefined || $.trim(val) === ''){ return true; }
      return this.regexs.int.test(val);
    },
    is_cifra: function(val){
      if(val === undefined || $.trim(val) === ''){ return true; }
      return this.regexs.it_number.test($.trim(val));
    },
    is_greater_than: function( el ){
      if(el.val() === undefined || $.trim(el.val()) === '' || el.attr('valore_min') === undefined || $.trim(el.attr('valore_min')) === ''){
        return true;
      }
      var array_valida = el.attr('valida').split(' ');
      if( $.inArray('data', array_valida) >= 0 ){
        return this.compare_date(el.val(), el.attr('valore_min'), 'greater-equal');
      }
      //attenzione gira su formato italiano
      return this.compare_decimal( this.italian_number_to_decimal(el.val()), this.italian_number_to_decimal(el.attr('valore_min')), el.attr('valore_uguale') !== undefined ? 'greater-equal' : 'greater' );
    },
    is_lower_than: function( el ){
      if(el.val() === undefined || $.trim(el.val()) === '' || el.attr('valore_max') === undefined || $.trim(el.attr('valore_max')) === ''){
        return true;
      }
      var array_valida = el.attr('valida').split(' ');
      if( $.inArray('data', array_valida) >= 0 ){
        return this.compare_date(el.val(), el.attr('valore_max'), 'lower-equal');
      }
      //attenzione gira su formato italiano
      return this.compare_decimal( this.italian_number_to_decimal(el.val()), this.italian_number_to_decimal(el.attr('valore_max')), el.attr('valore_uguale') !== undefined ? 'lower-equal' : 'lower' );
    },
    is_valid_regex: function( el ){
      if(el.val() === undefined || $.trim(el.val()) === '' || el.attr('rv_regex') === undefined || $.trim(el.attr('rv_regex')) === ''){
        return true;
      }
      return this.test( el.val(), el.attr('rv_regex') );
    },
    /* mask methods */
    set_mask_test: function( el ){
      if( el.prop('required_validate_mask_test') ){ return el; }
      el.prop('required_validate_mask_test', true);
      if( !el.attr('rv_mask') ){ return el; }
      el.on('keydown', function(e){
        if( e.key && !$.required_validate.test(e.key, $(this).attr('rv_mask')) ){ e.preventDefault(); return false; }
      });
      return el;
    },
    set_mask_cifra: function( $el ){
      var self = this;
      if( $el.prop('required_validate_mask_cifra') ){ return; }
      $el.prop('required_validate_mask_cifra', true);
      var force_decimals = $el.attr('not-force-decimals') === undefined;
      if( $el.val().length > 0 ){
        self.apply_italian_number_mask( $el, force_decimals );
      }
      var caret_pos = { begin: 0, end: 0 };
      var backup_len = 0;
      var ctrlDown = false;
      var ctrlKey = 17;
      var cmdKey = 91;
      var vKey = 86;
      var cKey = 67;
      var changed = false; //Protezione contro i browser che resettano lo status changed
      $el
        .onFirst('change', function(){
          if( /^,/.test($el.val()) ){
            $el.val( '0' + $el.val() );
          }
          if ($el.val() === '-') {
            $el.val('');
          }
          $el.val().length > 0 && self.apply_italian_number_mask( $el, force_decimals );
          changed = false;
        })
        .onFirst('blur', function(){
          changed && $el.trigger('change');
        })
        .on('keydown', function(e){
          var x = e.which || e.keyCode;
          var val = $el.val();
          caret_pos = self.caret($el);
          backup_len = val.length;

          if (x == ctrlKey || x == cmdKey){
            ctrlDown = true;
          }

          if( $.inArray( x, [190, 110] ) >= 0 && !/,/.test(val) ){
            $el.val( [val.slice(0, caret_pos.begin), ',', val.slice(caret_pos.begin)].join('') );
            return e.preventDefault();
          }

          if( $.inArray( x, [189, 109, 173] ) >= 0 && caret_pos.begin > 0) {
            return e.preventDefault();
          }

          if( (!ctrlDown && $.inArray( x, [48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 8, 9, 37, 39, 46, 188, 189, 109, 173] ) < 0) ||
            (ctrlDown && $.inArray( x, [vKey, cKey] ) < 0)){
            return e.preventDefault();
          }

          if( /,/.test(val) && $.inArray(x, [8, 9, 46, 37, 39]) < 0 ){
            if( x === 188 ) return e.preventDefault();
            var decimals = val.split('').reverse().join('').split(',')[0];
            if( decimals.length >= self.get_dec_length($el) && caret_pos.begin > val.indexOf(',') ){
              return e.preventDefault();
            }
          }
        })
        .on('keyup', function(e){
          var x = e.which || e.keyCode;
          var val = $el.val();
          var current_len = val.length;

          if (x == ctrlKey || x == cmdKey){
            ctrlDown = false;
          }

          if( $.inArray( x, [37, 39, 110, 190] ) >= 0 || current_len <= 0 ){
            return;
          }

          if( /^,/.test(val) ){
            return;
          }

          var last_is_comma = /,{1}$/.test(val);

          if( $.inArray( x, [189, 109, 173] ) < 0 && val !== '-') {
            self.apply_italian_number_mask( $el );
          }

          val = $el.val();

          if( last_is_comma ){
            val += ',';
            $el.val( val );
          }

          current_len = val.length;
          self.caret($el, caret_pos.begin + (current_len - backup_len) + ( caret_pos.end - caret_pos.begin ));
          changed = true;
        })
        .on('change', function(e){
          if ($el.val() === '-') {
            $el.val('');
          }
          return true;
        });
    },
    /* useful methods */
    caret: function($input, begin, end) {
      var range;
      var jsInput = $input.get(0);
      if ($input.length === 0 || $input.is(":hidden") || jsInput !== document.activeElement) {
        return;
      }
      if (typeof begin == 'number') {
        end = (typeof end === 'number') ? end : begin;
        if (jsInput.setSelectionRange) {
          jsInput.setSelectionRange(begin, end);
        } else if (jsInput.createTextRange) {
          range = jsInput.createTextRange();
          range.collapse(true);
          range.moveEnd('character', end);
          range.moveStart('character', begin);
          range.select();
        }
        return;
      }
      if (jsInput.setSelectionRange) {
        begin = jsInput.selectionStart;
        end = jsInput.selectionEnd;
      } else if (document.selection && document.selection.createRange) {
        range = document.selection.createRange();
        begin = 0 - range.duplicate().moveStart('character', -100000);
        end = begin + range.text.length;
      }
      return { begin: begin, end: end };
    },
    test: function(string, pattern){
      if(string.length <= 0 || pattern.length <= 0){ return true; }
      if( pattern[0] === '/' ){
        var patternParts = pattern.split('/');
        var flag = patternParts[ patternParts.length-1 ];
        var t = RegExp( pattern.substring(1, pattern.length - (flag.length <= 0 ? 1 : 2)), (flag.length <= 0 ? '' : flag) );
      } else {
        var t = new RegExp("^(" + pattern + ")+$", "i");
      }
      return t.test( string );
    },
    italian_number_to_decimal: function(v){
      return Number(v.replace(/\./g, '').replace(',', '.'));
    },
    compare_decimal: function(v1, v2, operator){
      var r = true;
      switch (operator){
        case 'greater':
          r = v1 > v2;
          break;
        case 'greater-equal':
          r = v1 >= v2;
          break;
        case 'lower':
          r = v1 < v2;
          break;
        case 'lower-equal':
          r = v1 <= v2;
          break;
        case 'equal':
          r = v1 == v2;
          break;
      }
      return r;
    },
    compare_date: function(d1, d2, operator){
      if(d1 === undefined || d1 === 'now'){ d1 = $.now(); }
      else { var d1_a = d1.split('/'); d1 = new Date(parseInt(d1_a[2], 10), parseInt(d1_a[1], 10) - 1, parseInt(d1_a[0], 10)).getTime(); }
      if(d2 === undefined || d2 === 'now'){ d2 = $.now(); }
      else { var d2_a = d2.split('/'); d2 = new Date(parseInt(d2_a[2], 10), parseInt(d2_a[1], 10) - 1, parseInt(d2_a[0], 10)).getTime(); }
      var r = true;
      switch (operator){
        case 'greater':
          r = d1 > d2;
          break;
        case 'greater-equal':
          r = d1 >= d2;
          break;
        case 'lower':
          r = d1 < d2;
          break;
        case 'lower-equal':
          r = d1 <= d2;
          break;
        case 'equal':
          r = d1 == d2;
          break;
      }
      return r;
    },
    get_italian_number_parts: function ( string, max_decimals, force_decimals ){
      var s = string.toString();
      var is_negative = s[0] === '-';
      if (is_negative) {
        s = s.slice(1);
      }
      var sa = s.split(',');
      if( sa.length < 2 ){ sa.push(''); }
      sa[0] = parseInt( sa[0].replace(/\./g, ''), 10 ).toString();
      sa[1] = sa[1].replace(/\./g, '');
      var int_part = '', dec_part = sa[1];
      for(var i = sa[0].length, c = 1; 0 < i; i--, c++){
        int_part = ((c % 3 === 0 && i > 1) ? '.' : '') + sa[0][ (i - 1) ] + int_part;
      }
      if( max_decimals === undefined ){ max_decimals = 2; }
      if( dec_part.length > max_decimals ){
        dec_part = dec_part.slice(0, max_decimals);
      }
      if( force_decimals === undefined ){ force_decimals = true; }
      if( force_decimals ){
        for(var i = (max_decimals - dec_part.length); 0 < i; i--){
          dec_part += '0';
        }
      }
      return {int: is_negative ? '-' + int_part : int_part, dec: dec_part };
    },
    get_dec_length: function( $input ){
      var len = $input.attr('dec-length');
      return len ? parseInt( len, 10 ) : 2;
    },
    apply_italian_number_mask: function ( $self, force_decimals ){
      if( force_decimals === undefined ){ force_decimals = false; }
      var parts = this.get_italian_number_parts( $self.val(), this.get_dec_length($self), force_decimals );
      $self.val( parts.int + (parts.dec.length > 0 ? (',' + parts.dec) : '') );
      return $self;
    },
    number_to_italian: function ( string, max_dec_lenght, force_decimals ){
      if( max_dec_lenght === undefined ){ max_dec_lenght = 2; }
      if( force_decimals === undefined ){ force_decimals = true; }
      var parts = this.get_italian_number_parts( string, max_dec_lenght, force_decimals );
      return parts.int + ( parts.dec.length > 0 ? (',' + parts.dec) : '' );
    },
    event_report: function(selector, root) {
      var s = [], sep = '\n' + Array(100).join('_') + '\n\n';
      $(selector || '*', root).andSelf().each(function() {
        var e = $._data(this, 'events'),
            temp_common_events = '';
        //cerco onchange onclick onmouseover onmouseout onkeydown onload
        var j_el = $(this);
        $.each(['onchange', 'onclick', 'onmouseover', 'onmouseout', 'onkeydown', 'onload'], function(i, onevent){
          if(j_el.attr(onevent)){
            temp_common_events += sep + onevent + ' handler' + '\n' + 'code: ' + j_el.attr(onevent);
          }
        });
        if(!e && temp_common_events.length <= 0) return;
        s.push(Array(100).join('#'), '\n');
        s.push('<', this.tagName, '> ');
        if(this.id) s.push('#', this.id, ' ');
        if(this.className) s.push('.', this.className.replace(/ +/g, '.'), ' ');
        if(this.name) s.push('name="', this.name, '" ');
        if(temp_common_events.length > 0){ s.push(temp_common_events); }
        for(var p in e){
          var r = e[p],
              h = r.length - r.delegateCount;
          if(h){
            s.push(sep, h, ' ', p, ' handler', h > 1 ? 's' : '');
          }
          if(r.delegateCount) {
            for(var q = 0; q < r.length; q++){
              if(r[q].selector) s.push('\n', p, ' for ', r[q].selector);
            }
          }
          for(var i = 0, l = r.length; i < l; i++){
            s.push('\n' , r[i].handler);
          }
        }
        s.push('\n\n');
      });
      return s.join('');
    }
  };

  /**
   * ## Expose
   * Inizializzazione della libreria, le funzionalita' sono esposte sulla proprieta' *$.required_validate*
   */
  var rv = new required_validate();
  rv.init();

  /**
   * ## Metodi pubblici
   * Tutti i metodi evocabili su oggetti jQuery figli della proprieta' *$.fn*
   */

  /**
   * #### required_validate
   * Attivazione della libreria su di una form
   * Es: `$(form).required_validate()`
   * @param {Object} options E' possibile passare un elenco di parametri per personalizzare il comportamento della validazione (vedi "Elenco parametri standard")
   */
  $.fn.required_validate = function( options ){
    if(!this.length){
      window.console && console.warn("Required validate: form non trovato");
      return this;
    }
    if(!$.required_validate) { var rv = new required_validate(); rv.init(); }
    for(var i = 0, l = this.length; i < l; i++){
      var $form = $(this[i]);
      var form_obj = $.required_validate.get_form_obj( $form.closest('form') );
      if( form_obj ){
        form_obj.options = $.extend({}, form_obj.options, options||{} );
        form_obj.validate();
      } else {
        $.required_validate.add_form( $form, options );
      }
    }
    return this;
  };

  /**
   * #### required_validate_is_this_form_valid
   * Su una form su cui e' stata attivata la validazione in precedenza e' possibile verificare se lo stato di validazione e' valido
   * Es: `$(form).required_validate_is_this_form_valid()`
   * @param {Boolean} revalidate Se impostato a true riesegue la validazione prima di ritornare lo stato
   * @returns {Boolean}
   */
  $.fn.required_validate_is_this_form_valid = function( revalidate ){
    if( this.length > 1 ){ return window.console && console.warn("Required validate is_this_form_valid: utilizzare il metodo sulla singola form"); }
    var form_obj = $.required_validate.get_form_obj( this );
    if( form_obj ){
      if( revalidate ){ form_obj.validate(); }
      var sb = form_obj.get_submit();
      return sb.length > 0 && !sb.eq(0).is(':disabled');
    }
    return false;
  };

  /**
   * #### required_validate_input_is_valid
   * Verifica lo stato di validazione di un singolo input
   * @returns {Boolean}
   */
  $.fn.required_validate_input_is_valid = function(){
    var $this = $(this).eq(0);
    return !$this.hasClass( $.required_validate.default_options.input_class ) ||
      $this.hasClass( $.required_validate.default_options.class_prefix + $.required_validate.default_options.valid_class );
  };

  /**
   * #### required_validate_is_email
   * Verifica per un oggetto input se il suo valore e' un indirzzo email
   * NB: Non e' necessario che l'imput sia figlio di una form con attiva la validazione
   * `$(input).required_validate_is_email();`
   * @return {Boolean}
   */
  $.fn.required_validate_is_email = function(){
    if( !this.val ){ return true; }
    return $.required_validate.is_email( this.val() );
  };

  /**
   * #### required_validate_is_codice_fiscale
   * Verifica per un oggetto input se il suo valore e' un codice fiscale
   * NB: Non e' necessario che l'imput sia figlio di una form con attiva la validazione
   * `$(input).required_validate_is_codice_fiscale();`
   * @return {Boolean}
   */
  $.fn.required_validate_is_codice_fiscale = function(){
    if( !this.val ){ return true; }
    return $.required_validate.is_codice_fiscale( this.val() );
  };

  /**
   * #### required_validate_is_partita_iva
   * Verifica per un oggetto input se il suo valore e' una partita iva
   * NB: Non e' necessario che l'imput sia figlio di una form con attiva la validazione
   * `$(input).required_validate_is_partita_iva();`
   * @return {Boolean}
   */
  $.fn.required_validate_is_partita_iva = function(){
    if( !this.val ){ return true; }
    return $.required_validate.is_partita_iva( this.val() );
  };

  /**
   * #### required_validate_is_cf_pi
   * Verifica per un oggetto input se il suo valore e' un codice fiscale o partita iva
   * NB: Non e' necessario che l'imput sia figlio di una form con attiva la validazione
   * `$(input).required_validate_is_cf_pi();`
   * @return {Boolean}
   */
  $.fn.required_validate_is_cf_pi = function(){
    if( !this.val ){ return true; }
    return $.required_validate.is_cf_pi( this.val() );
  };

  /**
   * #### required_validate_is_codice_fiscale_senza_zeri
   * Verifica per un oggetto input se il suo valore e' un codice fiscale non composto da soli '0'
   * NB: Non e' necessario che l'imput sia figlio di una form con attiva la validazione
   * `$(input).required_validate_is_codice_fiscale_senza_zeri();`
   * @return {Boolean}
   */
  $.fn.required_validate_is_codice_fiscale_senza_zeri = function(){
    if( !this.val ){ return true; }
    return $.required_validate.is_codice_fiscale_senza_zeri( this.val() );
  };

  /**
   * #### required_validate_is_partita_iva_senza_zeri
   * Verifica per un oggetto input se il suo valore e' una partita iva non composta da soli '0'
   * NB: Non e' necessario che l'imput sia figlio di una form con attiva la validazione
   * `$(input).required_validate_is_partita_iva_senza_zeri();`
   * @return {Boolean}
   */
  $.fn.required_validate_is_partita_iva_senza_zeri = function(){
    if( !this.val ){ return true; }
    return $.required_validate.is_partita_iva_senza_zeri( this.val() );
  };

  /**
   * #### required_validate_is_cf_pi_senza_zeri
   * Verifica per un oggetto input se il suo valore e' un codica fiscale o partita iva non composti da soli '0'
   * NB: Non e' necessario che l'imput sia figlio di una form con attiva la validazione
   * `$(input).required_validate_is_cf_pi_senza_zeri();`
   * @return {Boolean}
   */
  $.fn.required_validate_is_cf_pi_senza_zeri = function(){
    if( !this.val ){ return true; }
    return $.required_validate.is_cf_pi_senza_zeri( this.val() );
  };

  /**
   * #### required_validate_is_date
   * Verifica per un oggetto input se il suo valore e' una data in formato "gg/mm/aaaa"
   * NB: Non e' necessario che l'imput sia figlio di una form con attiva la validazione
   * `$(input).required_validate_is_date();`
   * @return {Boolean}
   */
  $.fn.required_validate_is_date = function(){
    if( !this.val ){ return true; }
    return $.required_validate.is_date( this.val() );
  };

  /**
   * #### required_validate_is_ora
   * Verifica per un oggetto input se il suo valore e' un orario in formato "hh:mm"
   * NB: Non e' necessario che l'imput sia figlio di una form con attiva la validazione
   * `$(input).required_validate_is_ora();`
   * @return {Boolean}
   */
  $.fn.required_validate_is_ora = function(){
    if( !this.val ){ return true; }
    return $.required_validate.is_ora( this.val() );
  };

  /**
   * #### required_validate_is_date_hour
   * Verifica per un oggetto input se il suo valore e' una data ora in formato "gg/mm/aaaa hh:ii"
   * NB: Non e' necessario che l'imput sia figlio di una form con attiva la validazione
   * `$(input).required_validate_is_date_hour();`
   * @return {Boolean}
   */
  $.fn.required_validate_is_date_hour = function(){
    if( !this.val ){ return true; }
    return $.required_validate.is_date_hour( this.val() );
  };

  /**
   * #### required_validate_is_url
   * Verifica per un oggetto input se il suo valore e' un url
   * NB: Non e' necessario che l'imput sia figlio di una form con attiva la validazione
   * `$(input).required_validate_is_url();`
   * @return {Boolean}
   */
  $.fn.required_validate_is_url = function(){
    if( !this.val ){ return true; }
    return $.required_validate.is_url( this.val() );
  };

  /**
   * #### required_validate_is_integer
   * Verifica per un oggetto input se il suo valore e' un intero
   * NB: Non e' necessario che l'imput sia figlio di una form con attiva la validazione
   * `$(input).required_validate_is_integer();`
   * @return {Boolean}
   */
  $.fn.required_validate_is_integer = function(){
    if( !this.val ){ return true; }
    return $.required_validate.is_integer( this.val() );
  };

  /**
   * #### required_validate_is_cifra
   * Verifica per un oggetto input se il suo valore e' una cifra
   * NB: Non e' necessario che l'imput sia figlio di una form con attiva la validazione
   * `$(input).required_validate_is_cifra();`
   * @return {Boolean}
   */
  $.fn.required_validate_is_cifra = function(){
    if( !this.val ){ return true; }
    return $.required_validate.is_cifra( this.val() );
  };

  /**
   * #### required_validate_is_greater_than
   * Verifica per un oggetto input se il suo valore e' maggiore di un valore base
   * NB: Non e' necessario che l'imput sia figlio di una form con attiva la validazione
   * Il valore base deve essere passato come attributo *valore_min* del tab input,
   * e' possibile specificare un ulteriore attributo *valore_uguale* per verificare se e' piu' grande o uguale:
   * - **valore_min** con valore numerico o data in formato 'gg/mm/aaaa'
   * - **valore_uguale** con valore *greater-equal* (default) o *greater*
   * Es: `<input type="text" valore_min="1000.50" value="" >`
   * `$(input).required_validate_is_greater_than();`
   * @return {Boolean}
   */
  $.fn.required_validate_is_greater_than = function(){
    if( !this.val ){ return true; }
    return $.required_validate.is_greater_than( this );
  };

  /**
   * #### required_validate_is_lower_than
   * Verifica per un oggetto input se il suo valore e' minore di un valore base
   * NB: Non e' necessario che l'imput sia figlio di una form con attiva la validazione
   * Il valore base deve essere passato come attributo *valore_max* del tab input,
   * e' possibile specificare un ulteriore attributo *valore_uguale* per verificare se e' piu' grande o uguale:
   * - **valore_max** con valore numerico o data in formato 'gg/mm/aaaa'
   * - **valore_uguale** con valore *lower-equal* (default) o *lower*
   * Es: `<input type="text" valore_min="1000.50" value="" >`
   * `$(input).required_validate_is_lower_than();`
   * @return {Boolean}
   */
  $.fn.required_validate_is_lower_than = function(){
    if( !this.val ){ return true; }
    return $.required_validate.is_lower_than( this );
  };

  /**
   * #### required_validate_is_valid_regex
   * Verifica per un oggetto input se il suo valore rispetta una espressione regolare
   * NB: Non e' necessario che l'imput sia figlio di una form con attiva la validazione
   * Il l'espressione regolare deve essere passata come attributo *rv_regex* del tab input
   * Es: `<input type="text" rv_regex="[0-9]|[a-z]" value="" >`
   * `$(input).required_validate_is_valid_regex();`
   * @return {Boolean}
   */
  $.fn.required_validate_is_valid_regex = function(){
    if( !this.val ){ return true; }
    return $.required_validate.is_valid_regex( this );
  };

  $.fn.required_validate_mask_test = function(){
    for( var i = 0, l = this.length; i < l; i++ ){
      $.required_validate.set_mask_test( this.eq(i) );
    }
    return this;
  };

  $.fn.required_validate_mask_cifra = function(){
    for( var i = 0, l = this.length; i < l; i++ ){
      $.required_validate.set_mask_cifra( this.eq(i) );
    }
    return this;
  };

  /**
   * #### required_validate_event_report
   * Se invocata genera un report nella console javascript di tutte le funzioni associate agli eventi per l'oggetto jQuery passato
   * `$(input).required_validate_event_report();`
   */
  $.fn.required_validate_event_report = function(el) {
    return $.required_validate.event_report(el, this);
  };

  /**
   * #### required_validate_custom_validation
   * Per specificare un funzione personalizzata da usare in fase di validazione. Es:
   * `$(input)`
   * `.required_validate_custom_validation(function(){`
   * `return $(this).val() == 1;`
   * `});`
   * @param {Function} rule_fun
   * @param {String} key_name Facoltativo, se non passato viene generata una key identificativa random
   */
  $.fn.required_validate_custom_validation = function(rule_fun, key_name) {
    if( !this.attr || !rule_fun || typeof rule_fun != 'function' ){
      return window.console && console.warn("Required validate: errore nella dichiarazione del metodo required_validate_custom_validation");
    }
    var v = 'rv_c_' + (key_name||function(){
      var rand = "", alphabet = "abcdefghijklmnopqrstuvwxyz";
      for(var i = 0; i < 3; i++){
        rand += alphabet.charAt(Math.floor(Math.random() * alphabet.length));
      }
      return (rand + $.now());
    }());
    $.required_validate[ v ] = rule_fun;
    return this.each(function(){
      var self = $(this);
      self.attr('valida', (self.attr('valida')||'') + ' ' + v );
    });
  };

  /**
   * ## DOM watcher
   */

  function dom_form_observer( target ){
    this.target = target;
    this.reloadInputProps = {
      timeout: 0,
      ms: 300,
      targets: []
    };
    this.observe_options = { childList: true, subtree: true };
    this.init();
  }

  dom_form_observer.prototype = {

    init: function(){
      if( !(this.target instanceof rv_form_obj) ) return;
      var element = this.target.$form[0];
      if( typeof MutationObserver === 'undefined' ){
        var self = this;
        element.addEventListener('DOMNodeInserted', function( node ){
          self.checkAddedNode( node.target );
        }, false);
        element.addEventListener('DOMNodeRemoved', function( node ){
          self.checkRemovedNode( node.target );
        }, false);
      } else {
        // Create an observer instance linked to the callback function
        this.observer = new MutationObserver( this.callback.bind(this) );
        // Start observing the target node for configured mutations
        this.observer.observe(element, this.observe_options);
      }
    },
    callback: function( mutationsList ){
      for(var i = 0, l = mutationsList.length; i < l; i++){
        var mutation = mutationsList[i];
        if(mutation.type !== 'childList') continue;
        for(var j = 0, k = mutation.addedNodes.length; j < k; j++){
          this.checkAddedNode( mutation.addedNodes[j] );
        }
        for(var j = 0, k = mutation.removedNodes.length; j < k; j++){
          this.checkRemovedNode( mutation.removedNodes[j], mutation.target );
        }
      }
    },
    realodInput: function( target ){
      var self = this;
      clearTimeout( self.reloadInputProps.timeout );
      self.reloadInputProps.targets.indexOf( target ) < 0 && self.reloadInputProps.targets.push( target );
      self.reloadInputProps.timeout = setTimeout(function(){
        for( var i = 0, l = self.reloadInputProps.targets.length; i < l; i++ ){
          self.reloadInputProps.targets[i].load_inputs( true ).validate();
        }
        self.reloadInputProps.targets = [];
      }, self.reloadInputProps.ms);
    },
    nodeIsInput: function( node ){
      return node instanceof HTMLInputElement ||
        node instanceof HTMLTextAreaElement ||
        node instanceof HTMLSelectElement;
    },
    nodeGetSubInput: function( node ){
      var tagToSearch = ['input', 'select', 'textarea'];
      var finded = false;
      for(var i = 0, l = tagToSearch.length; i < l; i++){
        var els = node.getElementsByTagName( tagToSearch[i] );
        if( els.length > 0 ){
          finded = els[0]; break;
        }
      }
      return finded;
    },
    checkAddedNode : function( addedNode ){
      if( addedNode.nodeType !== Node.ELEMENT_NODE ) return;
      var isInput = this.nodeIsInput( addedNode );
      var subInput = !isInput ? this.nodeGetSubInput( addedNode ) : false;
      if( isInput === false && subInput === false ) return;
      if( isInput && addedNode.name === 'session_id' ) return;
      this.realodInput( this.target );
    },
    checkRemovedNode : function( removedNode ){
      if( removedNode.nodeType !== Node.ELEMENT_NODE ) return;
      if( removedNode === this.target.$form[0] ){
        var i = $.required_validate.forms_obj.indexOf( this.target );
        i >= 0 && delete $.required_validate.forms_obj.splice(i, 1);
        return;
      }
      var isInput = this.nodeIsInput( removedNode );
      var subInput = !isInput ? this.nodeGetSubInput( removedNode ) : false;
      if( isInput === false && subInput === false ) return;
      this.realodInput( this.target );
    }
  };

  /**
   * ## *Array* Prototype
   * #### move_element
   * Metodo per spostare in un array gli elementi da un indice vecchio al nuovo
   * @param {Int} old_index
   * @param {Int} new_index
   * @return {Array} L'array modificato
   */
  Array.prototype.move_element = function (old_index, new_index) {
    if (new_index >= this.length) {
      var k = new_index - this.length;
      while ((k--) + 1) {
        this.push(undefined);
      }
    }
    this.splice(new_index, 0, this.splice(old_index, 1)[0]);
    return this;
  };

}(jQuery);
